import 'dhtmlx-scheduler'
import 'dhtmlx-scheduler/codebase/dhtmlxscheduler_material.css'
import 'dhtmlx-scheduler/codebase/ext/dhtmlxscheduler_key_nav'

export const { scheduler } = window as any
